import { render, staticRenderFns } from "./SortBy.vue?vue&type=template&id=a5a7097a&scoped=true"
import script from "./SortBy.vue?vue&type=script&lang=js"
export * from "./SortBy.vue?vue&type=script&lang=js"
import style0 from "./SortBy.vue?vue&type=style&index=0&id=a5a7097a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a7097a",
  null
  
)

export default component.exports